import { render } from "./AddPaywallModal.vue?vue&type=template&id=4a5eea78&scoped=true"
import script from "./AddPaywallModal.vue?vue&type=script&lang=js"
export * from "./AddPaywallModal.vue?vue&type=script&lang=js"

import "./AddPaywallModal.vue?vue&type=style&index=0&id=4a5eea78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5eea78"]])

export default __exports__